/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from "react";
import { connectBetPlacing } from "./BetPlacing.connect";
import { BetPopoverContext } from "../../context";
import { getCurrencyFormat } from "../../helpers/getCurrencyFormat.helper";
import { payloadSetter } from "../../helpers/payloadSetter";
import { useLocation } from "react-router-dom";
import SVG_Loading from "../../assets/images/svgs/loading.svg?react";
import SVG_TimerIcon from "../../assets/images/svgs/timer.svg?react";
import SVG_TimerDarkIcon from "../../assets/images/svgs/timerDark.svg?react";
import { minmaxGetter } from "../../helpers/minmaxformatter";
import { toastr } from "react-redux-toastr";
import { USER_DATA } from "../../config/app.config";
import { UNICON_THEME } from "../../config/api.config";

// eslint-disable-next-line react-refresh/only-export-components
const BetPlacing = ({
  betPlacing,
  // presetStakeSettings,
  stakes,
  actions,
  oneClick,
  // headerHeight,
  sportEvent,
  auth,
  // user,
  // messages,
  // notifications,
  // heightForBetslip,
  onClose,
}) => {
  const cancelBetPopover = useContext(BetPopoverContext);
  const [incremented, setIncremented] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [styles, setStyles] = useState({ transform: "translateY(-100%)" });
  const [isOpenAnimation, setOpenAnimation] = useState(true);
  const location = useLocation();
  const [editStakes, setEditStakes] = useState(false);
  const [isStakesUpdating, setStakesUpdaing] = useState(false);
  const [stakeButtons, setStakeButtons] = useState([]);
  // const { eventTypeId } = useParams();
  const [minMaxStakes, setMinMaxStakes] = useState({ min: 0, max: 0 });

  let userDetail = localStorage.getItem(USER_DATA);
  let userData = JSON.parse(userDetail);

  let dataOdd = sportEvent?.sportData;

  useEffect(() => {
    let timer;

    if (betPlacing?.market && !betPlacing.isSubmitting) {
      timer = setTimeout(() => {
        // cancel();
      }, 8000);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [betPlacing?.market, betPlacing.isSubmitting]);

  useEffect(() => {
    if (stakes?.length <= 0 && auth) {
      actions.requestStakeButtons();
    }
  }, [auth]);

  useEffect(() => {
    if (stakes?.length) {
      setStakeButtons(stakes);
    }
  }, [stakes]);

  useEffect(() => {
    if (stakes?.length > 0 && minMaxStakes?.max == 0) {
      // Extract all price values from the data
      const prices = stakes.flatMap((obj) =>
        Object.keys(obj)
          .filter((key) => key.startsWith("price"))
          .map((key) => obj[key])
      );

      // Calculate min and max values
      const min = Math.min(...prices);
      const max = Math.max(...prices);

      // Update the state with min and max values
      setMinMaxStakes({ min, max });
    }
  }, [stakes]);

  useEffect(() => {
    if (!!betPlacing?.marketType) {
      setTimeout(() => setStyles({ transform: "translateY(0px)" }), 200);
      setOpenAnimation(true);
    }
  }, [betPlacing?.marketType]);

  function betDelayLoader() {
    let betDelay = 0;
    if (
      betPlacing.marketType == "MATCH_ODDS" &&
      betPlacing.eventTypeId == "4"
    ) {
      //Match Odds Cricket
      betDelay = parseInt(betPlacing?.betDelay?.matchoddsBetDelay || 5);
    } else if (
      betPlacing.marketType == "MATCH_ODDS" &&
      betPlacing.eventTypeId == "1"
    ) {
      // Match Odds Football
      betDelay = parseInt(betPlacing?.betDelay?.soccerBetDelay || 5);
    } else if (
      betPlacing.marketType == "MATCH_ODDS" &&
      betPlacing.eventTypeId == "2"
    ) {
      // Match Odds Tennis
      betDelay = parseInt(betPlacing?.betDelay?.tennisBetDelay || 5);
    } else if (betPlacing.marketType == "Special") {
      // Bookmaker
      betDelay = parseInt(betPlacing?.betDelay?.bookmakerBetDelay || 5);
    } else if (betPlacing.marketType == "SESSION") {
      // Session
      betDelay = parseInt(betPlacing?.betDelay?.fancyBetDelay || 5);
    } else if (betPlacing.eventTypeId == "v9") {
      betDelay = parseInt(betPlacing?.betDelay?.virtualBetDelay || 5);
    } else if (betPlacing.eventTypeId == "b9") {
      betDelay = parseInt(betPlacing?.betDelay?.ballbyballBetDelay || 5);
    } else {
      betDelay = 5;
    }
    return betDelay;
  }

  const profit = () => {
    const type = betPlacing.isBack ? "Profit" : "Liability";
    const isFancy = betPlacing.marketType == "SESSION";
    const stake = betPlacing.stake
      ? isFancy
        ? getCurrencyFormat((betPlacing.stake * betPlacing.fancyPrice) / 100)
        : getCurrencyFormat(
          betPlacing.stake * betPlacing.priceActual - betPlacing.stake
        )
      : "0.00";
    return (
      <span className="text-[10px] sm:text-xs text-white">
        <div>
          <span>{type} : </span>
          <span>{stake}</span>
        </div>
      </span>
    );
  };
  const cancel = () => {
    setStyles({ transform: "translateY(-100%)", transition: "300ms ease" });
    if (window?.innerWidth >= 1024) {
      onClose();
    }

    setOpenAnimation(false);

    setTimeout(() => {
      actions.setMarket(null);
      actions.setRunner(null);
      actions.setIsBack(null);
      actions.setPrice(null);
      actions.setPriceActual(null);
      actions.setStake(null);
      actions.setMarketType(null);
      actions.setMarketName(null);
      actions.setFancyPrice(null);
      actions.setIsCashOut(false);
      actions.setIsSubmitting(false);
    }, 200);
  };

  //close betslip if selected market is closed
  useEffect(() => {
    if (
      dataOdd &&
      dataOdd[0]?.competition?.name === "Live Games" &&
      !dataOdd.filter((item) => item.id === betPlacing?.market)[0]?.isBettable
    ) {
      // cancel()
    }
  }, [dataOdd]);

  const calculateStack = (market, isBack) => {
    if (isBack) {
      return Number(market?.ex?.availableToBack[0]?.price); // example stack value
    } else {
      return Number(market?.ex?.availableToLay[0]?.price); // different stack value
    }
  };

  const submit = async () => {
    if (betPlacing.confirmation) actions.setBetPlacingPopoverStage(false);

    if (betPlacing.marketType == "TO_WIN_THE_TOSS") {
      let currentTime = new Date();
      const matchDate = new Date(betPlacing.startTime)
      let oneHourBefore = new Date((matchDate).getTime() - (60 * 60 * 1000));
      if (currentTime > oneHourBefore) {
        toastr.error("", "Market is closed");
        cancelBetPopover();
        cancel();
        return;
      }
      else {

        actions.setBetPlacingPopoverStage(true);

        if (betPlacing.line) {
          if (betPlacing.price <= 1) {
            toastr.error("", "Bhaw cannot be less than 1.");
            return;
          }
          actions
            .requestSetFancyOrder(betPlacing)
            .then((res) => {
              // const text = getPlacingText(betPlacing, res)
              if (res?.data) {
                res?.data?.status
                  ? toastr.success("", res?.data?.msg)
                  : toastr.error("", res?.data?.msg);
              }
              actions.requestOpenBets();
              actions.requestUnMatchedBets();
              cancelBetPopover();
            })
            .catch((e) => {
              cancelBetPopover();
              if (e?.msg) toastr.error("", e?.msg);
              else if (e[0] && e[0][0] && e[0][0].description)
                toastr.error("", e[0][0].description);
              else toastr.error("", "Something went wrong");
            });
        } else if (betPlacing?.marketAll?.isHrBet) {
          let selection = betPlacing?.marketAll?.selection;
          let stake = Number(betPlacing.stake);
          let isBack = betPlacing?.isBack;
          let totalOdds = isBack
            ? betPlacing.marketAll?.totalOddsBack.toFixed(2)
            : betPlacing.marketAll?.totalOddsLay.toFixed(2);

          let equalAmount = isBack ? stake / totalOdds : stake / totalOdds;

          const newArray = selection.map((market) => ({
            selection_id: market.selectionId,
            selection_name: market.selection_name,
            market_id: market.market_id,
            odds: calculateStack(market, isBack),
            is_back: isBack ? 1 : 0,
            stack: Number(
              (calculateStack(market, isBack) * equalAmount).toFixed(0)
            ),
          }));

          actions
            .requestHROrder(newArray)
            .then((res) => {
              if (res?.data) {
                res?.data?.status
                  ? toastr.success("", res?.data?.msg)
                  : toastr.error("", res?.data?.msg);
              }
              cancelBetPopover();
              actions.requestOpenBets();
              actions.requestUnMatchedBets();
            })
            .catch((e) => {
              cancelBetPopover();
              if (e?.msg) toastr.error("", e?.msg);
              else toastr.error("", "Something went wrong");
            });
        } else {
          actions
            .requestSetOrder(betPlacing)
            .then((res) => {
              // const text = getPlacingText(betPlacing, res)
              if (res?.data) {
                res?.data?.status
                  ? toastr.success("", res?.data?.msg)
                  : toastr.error("", res?.data?.msg);
              }
              actions.requestOpenBets();
              actions.requestUnMatchedBets();
              cancelBetPopover();
            })
            .catch((e) => {
              cancelBetPopover();
              if (e?.msg) toastr.error("", e?.msg);
              else toastr.error("", "Something went wrong");
            });
        }

      }

    }



    else {
      actions.setBetPlacingPopoverStage(true);

      if (betPlacing.line) {
        if (betPlacing.price <= 1) {
          toastr.error("", "Bhaw cannot be less than 1.");
          return;
        }
        actions
          .requestSetFancyOrder(betPlacing)
          .then((res) => {
            // const text = getPlacingText(betPlacing, res)
            if (res?.data) {
              res?.data?.status
                ? toastr.success("", res?.data?.msg)
                : toastr.error("", res?.data?.msg);
            }
            actions.requestOpenBets();
            actions.requestUnMatchedBets();
            cancelBetPopover();
          })
          .catch((e) => {
            cancelBetPopover();
            if (e?.msg) toastr.error("", e?.msg);
            else if (e[0] && e[0][0] && e[0][0].description)
              toastr.error("", e[0][0].description);
            else toastr.error("", "Something went wrong");
          });
      } else if (betPlacing?.marketAll?.isHrBet) {
        let selection = betPlacing?.marketAll?.selection;
        let stake = Number(betPlacing.stake);
        let isBack = betPlacing?.isBack;
        let totalOdds = isBack
          ? betPlacing.marketAll?.totalOddsBack.toFixed(2)
          : betPlacing.marketAll?.totalOddsLay.toFixed(2);

        let equalAmount = isBack ? stake / totalOdds : stake / totalOdds;

        const newArray = selection.map((market) => ({
          selection_id: market.selectionId,
          selection_name: market.selection_name,
          market_id: market.market_id,
          odds: calculateStack(market, isBack),
          is_back: isBack ? 1 : 0,
          stack: Number(
            (calculateStack(market, isBack) * equalAmount).toFixed(0)
          ),
        }));

        actions
          .requestHROrder(newArray)
          .then((res) => {
            if (res?.data) {
              res?.data?.status
                ? toastr.success("", res?.data?.msg)
                : toastr.error("", res?.data?.msg);
            }
            cancelBetPopover();
            actions.requestOpenBets();
            actions.requestUnMatchedBets();
          })
          .catch((e) => {
            cancelBetPopover();
            if (e?.msg) toastr.error("", e?.msg);
            else toastr.error("", "Something went wrong");
          });
      } else {
        actions
          .requestSetOrder(betPlacing)
          .then((res) => {
            // const text = getPlacingText(betPlacing, res)
            if (res?.data) {
              res?.data?.status
                ? toastr.success("", res?.data?.msg)
                : toastr.error("", res?.data?.msg);
            }
            actions.requestOpenBets();
            actions.requestUnMatchedBets();
            cancelBetPopover();
          })
          .catch((e) => {
            cancelBetPopover();
            if (e?.msg) toastr.error("", e?.msg);
            else toastr.error("", "Something went wrong");
          });
      }
    }
    actions.setShowBetPlacingPopover(true);
  };

  const ripple = (event) => {
    const elem = event.currentTarget;

    var rect = event.target.getBoundingClientRect();
    let x = event.clientX - elem.offsetLeft;
    let y = rect.height - rect.bottom + event.clientY;
    let rippleElement = document.createElement("span");
    rippleElement.style.left = x + "px";
    rippleElement.style.top = y + "px";
    elem.appendChild(rippleElement);
    setTimeout(function () {
      rippleElement.remove();
    }, 500);
  };

  // const changeOddRipple = (event, mod, isChanging = 1) => {
  //     const ev = {...event}
  //     ripple(event)
  //     changeOdd(mod, isChanging)
  // }

  const changeOdd = (mod, isChanging = 1) => {
    let step, dec;
    const odd = Number(betPlacing.priceActual);
    switch (true) {
      case odd < 2: {
        step = 0.01;
        dec = 2;
        break;
      }
      case odd < 3: {
        step = 0.02;
        dec = 2;
        break;
      }
      case odd < 4: {
        step = 0.05;
        dec = 2;
        break;
      }
      case odd < 6: {
        step = 0.1;
        dec = 2;
        break;
      }
      case odd < 10: {
        step = 0.2;
        dec = 2;
        break;
      }
      case odd < 20: {
        step = 0.5;
        dec = 1;
        break;
      }
      case odd < 30: {
        step = 1;
        dec = 0;
        break;
      }
      case odd < 50: {
        step = 2;
        dec = 0;
        break;
      }
      case odd < 100: {
        step = 5;
        dec = 0;
        break;
      }
      default: {
        step = 10;
        dec = 0;
      }
    }
    let newVal = +(odd + step * mod * isChanging).toFixed(2);
    if (newVal < 1.01) newVal = 1.01;
    else if (newVal > 1000) newVal = 1000;
    else if (!Number.isInteger(newVal / step))
      newVal = newVal - (newVal % step) + step;
    newVal = Number(newVal.toFixed(dec));
    actions.setPriceActual(newVal);
  };

  // another variant
  const renderOdd = () => {
    if (betPlacing?.marketType == "SESSION")
      return (
        <span title="Odds" className=" col-span-6 pt-1.5 w-full">
          <div className=" w-full grid grid-cols-2 gap-x-2 min-h-[35px]">
            <span className=" col-span-1 overflow-hidden h-full">
              <input
                id="oddInput"
                inputMode="numeric"
                className=" focus:outline-none  focus:bg-inherit text-sm w-full h-full text-center rounded-[4px] flex items-center justify-center text-text_Ternary  focus:border-oddInputBorderActive active:border-oddInputBorderActive"
                disabled
                autoComplete="off"
                max="1000"
                min="0"
                pattern="^[+-ed]+$"
                type="number"
                onChange={(e) => { }}
                value={betPlacing.fancyPrice || ""}
              />
            </span>
            <span className=" col-span-1 h-full overflow-hidden">
              <input
                id="oddInput"
                inputMode="numeric"
                className=" w-full focus:outline-none focus:bg-inherit text-sm h-full text-center rounded-[4px] flex items-center justify-center text-text_Primary border-oddInputColor focus:border-oddInputBorderActive active:border-oddInputBorderActive"
                autoComplete="off"
                max="1000"
                min="0"
                pattern="^[+-ed]+$"
                type="number"
                value={betPlacing.priceActual || ""}
                onChange={(e) => { }}
                disabled
              />
            </span>
          </div>
        </span>
      );

    return (
      <span title="Odds" className=" col-span-5 pt-1.5 w-full">
        {/* <div className=" grid grid-cols-12 min-h-[35px]"> */}
        {/* <span className="col-span-12 h-full pr-1 overflow-hidden">
            <input
              id="oddInput"
              inputMode="numeric"
              className=" focus:outline-none  text-sm w-full h-full text-center py-1 flex items-center justify-center border-[0.25px] text-text_Ternary   border-oddInputBorder focus:border-oddInputBorderActive active:border-oddInputBorderActive"
              validations="[object Object]"
              autoComplete="off"
              max="1000"
              min="0"
              pattern="^[+-ed]+$"
              type="number"
              value={betPlacing.priceActual}
              disabled
              onChange={(e) => actions.setPriceActual(e.detail.value)}
              onBlur={() => changeOdd(1, 0)}
            />
          </span> */}
        <div className="flex items-center justify-center min-h-[33px]">
          {/* <button
            onClick={() =>
              actions.setPriceActual(Number(betPlacing.priceActual - 0.05))
            }
            className="min-h-[33px] overflow-hidden w-full  flex items-center justify-center bg-bg_color_betSlipOddIncDecrBtnsGrd rounded-s-[4px] border border-border_color_primary4 border-r-0 text-xl font-normal text-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={18}
              height={4}
              viewBox="0 0 18 4"
              fill="none"
            >
              <path
                d="M16.3363 3.1535H1.66367C1.02639 3.1535 0.51001 2.63713 0.51001 1.99985C0.51001 1.36257 1.02639 0.846191 1.66367 0.846191H16.3363C16.9736 0.846191 17.49 1.36257 17.49 1.99985C17.49 2.63713 16.9736 3.1535 16.3363 3.1535Z"
                fill="var(--icon-color-secondary)"
              />
            </svg>
          </button> */}
          <input
            value={betPlacing.priceActual}
            disabled
            onChange={(e) => actions.setPriceActual(e.detail.value)}
            onBlur={() => changeOdd(1, 0)}
            placeholder="Enter Odds"
            inputMode="numeric"
            className={`block min-h-[33px] rounded-md h-full w-full focus:outline-none focus:bg-inherit text-sm w-full  py-2 text-center  flex items-center justify-center  ${UNICON_THEME ? "border-[0.25px] text-black" : "bg-bg_color_input_bg text-text_color_primary1"}  focus:border-border_color_activeInput active:border-border_color_activeInput`}
            autoComplete="off"
            pattern="^[+-ed]+$"
            type="number"
            defaultValue="3.35"
          />
          {/* <button
            onClick={() =>
              actions.setPriceActual(Number(betPlacing.priceActual + 0.05))
            }
            className="overflow-hidden min-h-[33px] w-full h-full flex items-center justify-center bg-bg_color_betSlipOddIncDecrBtnsGrd rounded-e-[4px] border border-border_color_primary4 border-r-0 text-xl font-normal text-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={18}
              height={18}
              viewBox="0 0 18 18"
              fill="none"
            >
              <path
                d="M8.99997 17.4897C8.36269 17.4897 7.84631 16.9734 7.84631 16.3361V1.66342C7.84631 1.02614 8.36269 0.509766 8.99997 0.509766C9.63725 0.509766 10.1536 1.02614 10.1536 1.66342V16.3361C10.1536 16.9734 9.63725 17.4897 8.99997 17.4897Z"
                fill="var(--icon-color-secondary)"
              />
              <path
                d="M16.3363 10.1535H1.66367C1.02639 10.1535 0.51001 9.63713 0.51001 8.99985C0.51001 8.36257 1.02639 7.84619 1.66367 7.84619H16.3363C16.9736 7.84619 17.49 8.36257 17.49 8.99985C17.49 9.63713 16.9736 10.1535 16.3363 10.1535Z"
                fill="var(--icon-color-secondary)"
              />
            </svg>
          </button> */}
        </div>
        {/* </div> */}
      </span>
    );
  };

  useEffect(() => {
    if (incremented) setTimeout(() => setIncremented(false), 300);
  }, [incremented]);

  const increment = (i) => {
    setIncremented(true);
    actions.setStake((betPlacing.stake ? Number(betPlacing.stake) : 0) + i);
  };

  // const incrementNotAuth = (i) => {
  //     setIncremented(true)
  //     actions.setStake((betPlacing.stake ? Number(betPlacing.stake) : 0) + i)
  // }

  const minMaxIncrement = (type) => {
    const minmax = minmaxGetter(
      betPlacing?.minMaxAll,
      betPlacing?.eventTypeId,
      betPlacing?.marketType
    );
    if (minmax?.min && minmax?.max) {
      let value = type == "min" ? minmax?.min : minmax?.max;
      setIncremented(true);
      actions.setStake(Number(value) || 0);
    }
  };

  const handleStakeChange = (e, index) => {
    e.preventDefault();
    const numVal = Number(e.target.value);

    if (Number.isInteger(numVal)) {
      setStakeButtons((prev) => {
        // Condition 1: Value exceeds the maximum limit
        if (numVal > 10000000) {
          toastr.error("", "Value cannot exceed 1,00,00,000.");
          return prev;
        }

        // Check if the max value already exists
        const hasMaxValue = prev.includes(10000000);

        return prev.map((item, i) =>
          i === index
            ? numVal === 10000000
              ? // Condition 2: Attempting to set multiple max values
              hasMaxValue && index !== prev.indexOf(10000000)
                ? (toastr.error("", "Only one value can be 1,00,00,000."), item)
                : numVal
              : numVal
            : item
        );
      });
    } else {
      toastr.error("", "Please enter a valid integer.");
    }
  };

  const handleStakesSubmit = () => {
    if (userData?.is_demo) {
      toastr.error("", "Please login from your read ID.");
      return;
    }

    setStakesUpdaing(true);

    actions
      .requestUpdateStakeButtons(stakeButtons)
      .then(() => {
        setStakesUpdaing(false);
        setEditStakes(false);
      })
      .catch(() => {
        setStakesUpdaing(false);
        setEditStakes(false);
        // cancel();
      });
  };

  return oneClick ? null : (
    <>
      {!!betPlacing?.market ? (
        <div
          title="Bet Slip"
          id="betSlipPlaceorder"
          // className={`w-full bg-bg_BetSlipBgColor text-selection-none border-[2px] border-b-[5px] font-lato  origin-top transition-all ease-in-out p-2 rounded-sm ${isOpenAnimation? 'scaleVerticalOpen' : 'scaleVerticalClose'} ${betPlacing?.isBack? 'border-backBtn' : 'border-layBtn'}`}
          className={`w-full bg-bg_BetSlipBgColor text-selection-none border-[2px] border-b-[5px] font-lato  origin-top transition-all ease-in-out p-2 rounded-sm ${isOpenAnimation ? "scaleVerticalOpen" : "scaleVerticalClose"
            } ${betPlacing?.isBack ? "border-backBtn" : "border-layBtn"}`}
        >
          <div
            id="topPartOfBetSlip"
            title="Bet Slip Top Part"
            className={`grid grid-cols-12 pt-[2px] gap-x-[15px] `}
          >
            {betPlacing?.marketType == "SESSION" ? (
              <>
                <span className={` col-span-3  text-[12px]  ${UNICON_THEME ? "text-black" : "text-white"}   font-normal  text-center`}>
                  ODDS(H-J)
                </span>
                <span className={` col-span-3  text-[12px]  ${UNICON_THEME ? "text-black" : "text-white"} font-normal  text-center`}>
                  RUNS
                </span>
              </>
            ) : (
              <span className={` col-span-5  text-[12px]  ${UNICON_THEME ? "text-black" : "text-white"}   font-normal`}>
                ODDS
              </span>
            )}

            <div className={` col-span-7 w-full flex items-center justify-between ${UNICON_THEME ? "text-black" : "text-white"} `}>
              <span className="text-[12px]  text-inherit font-normal text-start pl-1">
                STAKE
              </span>
              <span className=" text-[12px] float-right capitalize text-inherit 5 font-normal text-center">
                Max Mkt :{" "}
                {getCurrencyFormat(betPlacing?.maxWinPerMarket) || "5,00,000"}
              </span>
            </div>
            {renderOdd()}

            <span
              title="Stakes"
              className=" col-span-7 pt-1.5 w-full px-[1px] overflow-hidden"
            >
              <input
                id="stakeInput"
                inputMode="numeric"
                className={`block w-full h-full text-md text-center flex items-center justify-center border-border_color_primary placeholder:!text-white  ${UNICON_THEME ? "text-black  border-[0.25px] active:border-red-700 active:text-black" : "text-text_color_primary1  border-[0.75px] focus:bg-black active:bg-black"}    bg-transparent rounded-sm focus:outline-none  ${incremented ? "increaseStakesValue" : ""}`}

                placeholder={`Max : ${getCurrencyFormat(
                  minmaxGetter(
                    betPlacing?.minMaxAll,
                    betPlacing?.eventTypeId,
                    betPlacing?.marketType
                  )?.max
                ) || "0"
                  }`}
                autoComplete="off"
                pattern="d*"
                type="number"
                value={betPlacing?.stake || ""}
                onChange={(e) => {
                  const numVal = Number(e.target.value);

                  if (Number.isInteger(numVal)) {
                    if (numVal > 10000000) {
                      toastr.error("", "Value cannot exceed 1,00,00,000.");
                      return;
                    }
                  }

                  if (auth) {
                    actions.setStake(
                      String(e.target.value).replace(
                        /^([0-9]*[.,][0-9]{2})([0-9]+)$/,
                        "$1"
                      )
                    );
                  } else {
                    if (Number(e.target.value) > 500000) {
                      actions.setStake(
                        String(500000).replace(
                          /^([0-9]*[.,][0-9]{2})([0-9]+)$/,
                          "$1"
                        )
                      );
                    } else {
                      actions.setStake(
                        String(e.target.value).replace(
                          /^([0-9]*[.,][0-9]{2})([0-9]+)$/,
                          "$1"
                        )
                      );
                    }
                  }
                }}
              />
            </span>
          </div>

          <div className={` mt-[15px] p-2.5 rounded-md border border-borderColorOfMarket  bg-bg_InActivePlaceBtnColor `}>
            {!!editStakes ? (
              <div className=" grid grid-cols-12 gap-x-1 gap-y-1">
                {stakeButtons?.length > 0 &&
                  stakeButtons.map((item, index) => {
                    return (
                      <input
                        key={`index_${index}`}
                        inputMode="numeric"
                        className={`block focus:outline-none focus:bg-inherit border-[#ef8402] col-span-4 overflow-hidden w-full text-[12px] font-semibold rounded-[4px] py-1.5 bg-bg_Quaternary ${UNICON_THEME ? "text-black" : "text-text_Primary"}  text-center border  focus:border-primary `}
                        placeholder="Enter Stake"
                        autoComplete="off"
                        type="number"
                        value={item || ""}
                        onChange={(e) => {
                          handleStakeChange(e, index);
                        }}
                      />
                    );
                  })}
              </div>
            ) : (
              <div className=" grid grid-cols-12 gap-x-1 gap-y-1">
                {stakes?.length > 0 &&
                  stakes.map((item, index) => {
                    return (
                      <button
                        key={`${item}` + index}
                        className={`inline-block  border-[#bd3725] leading-normal relative  transition duration-150 ease-in-out col-span-4 w-full overflow-hidden border  text-[12px] font-semibold rounded-[4px]  text-text_Quaternary text-center py-1.5  cursor-pointer ${UNICON_THEME ? "bg-bg_text_brand_primary" : ""} `}
                        type="button"
                        onClick={() => {
                          increment(item);
                        }}
                      >
                        <span>+ {getCurrencyFormat(item) || 0}</span>
                      </button>
                    );
                  })}
              </div>
            )}

            {auth && (
              <div className=" grid grid-cols-12 gap-x-1 gap-y-1 pt-[15px]">
                <button
                  className="inline-block  leading-normal relative overflow-hidden  transition duration-150 ease-in-out col-span-3 w-full text-[10px] min-h-[26px]  font-semibold  rounded-[4px] bg-minBtnGrd text-text_Quaternary py-2  cursor-pointer"
                  type="button"
                  onClick={() => {
                    stakes[0] ? increment(stakes[0]) : minMaxIncrement("min");
                  }}
                >
                  MIN
                </button>
                <button
                  className="inline-block  leading-normal relative overflow-hidden  transition duration-150 ease-in-out col-span-3 w-full text-[10px] font-semibold rounded-[4px] bg-maxBtnGrd text-text_Quaternary py-2  cursor-pointer"
                  type="button"
                  onClick={() =>
                    stakes[stakes?.length - 1]
                      ? increment(stakes[stakes?.length - 1])
                      : minMaxIncrement("max")
                  }
                >
                  MAX
                </button>

                <button
                  className={`inline-block  leading-normal relative overflow-hidden  transition duration-150 ease-in-out col-span-3 w-full text-[10px]  font-semibold rounded-[4px] text-text_Quaternary py-2  ${editStakes ? "" : "bg-editStakesGrd"
                    } cursor-pointer`}
                  type="button"
                  disabled={editStakes && isStakesUpdating}
                  onClick={() => {
                    if (!editStakes) {
                      setEditStakes(true);
                    } else {
                      handleStakesSubmit();
                    }
                  }}
                >
                  {editStakes ? (
                    <>
                      UPDATE
                      <span
                        className="ripple"
                        style={{
                          height: "94px",
                          width: "94px",
                          left: "19px",
                          top: "-757px",
                        }}
                      ></span>
                      {editStakes && isStakesUpdating && (
                        <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                          <SVG_Loading />
                        </span>
                      )}
                    </>
                  ) : (
                    <>EDIT STAKES</>
                  )}
                </button>
                <button
                  className="inline-block  relative overflow-hidden  transition duration-150 ease-in-out col-span-3 w-full text-[10px] font-semibold rounded-[4px] bg-clearBtnGrd text-text_Quaternary leading-4 py-2  cursor-pointer"
                  id="clearBtn"
                  type="button"
                  onClick={() => {
                    setIncremented(true);
                    actions.setStake(0);
                  }}
                >
                  CLEAR
                </button>
              </div>
            )}
          </div>

          {betPlacing.priceActual !== betPlacing.price &&
            (betPlacing.marketType == "MATCH_ODDS" ||
              betPlacing.marketType == "Special" ||
              betPlacing.marketType == "SESSION") && (
              <div className="text-center my-0.5 text-sm text-text_Primary mt-3.5 py-1 bg-bg_BackgroundColorForOddChange rounded-sm border border-borderColorFoprOddChange">
                <span>The odds of your selection have changed.</span>
              </div>
            )}

          <div className=" flex items-center justify-center gap-x-[13px] pt-3.5 w-full">
            <button
              type="button"
              className={` leading-normal ${UNICON_THEME ? "border-[#6e081d] text-[gray]" : "border-[#ef8402] text-text_BetSlipCancelBtnColor"}   relative overflow-hidden  transition duration-150 ease-in-out  px-5 py-2.5 w-[50%] max-w-[156px] flex items-center justify-center min-h-[46px] text-sm bg-transperent  font-medium border rounded-md  cursor-pointer`}
              onClick={cancel}
            >
              <span className={`${UNICON_THEME ? "text-gray-400" : "text-text_brand_primary"}  font-bold text-base leading-5`}>
                Cancel Bet
              </span>
            </button>
            <div className="w-[50%] max-w-[156px] h-max">
              <button
                disabled={
                  Number(betPlacing.stake) <= 0 ||
                  Number(betPlacing.priceActual) < 1.01 ||
                  isLoading
                }
                type="button"
                className={` leading-normal  overflow-hidden  transition duration-150 ease-in-out py-1 relative w-full flex  min-h-[46px] px-2.5 rounded-md  font-medium border  flex-row items-center justify-between  ${Number(betPlacing.stake) <= 0 ||
                    Number(betPlacing.priceActual) < 1.01 ||
                    isLoading
                    ? "bg-bg_InActivePlaceBtnColors text-text_Ternary 5 border-inActivePlaceBtnColor"
                    : "bg-placeBetBtnGrd text-text_Quaternary border-primary"
                  }  cursor-pointer`}
                onClick={() => {
                  if (!auth) {
                    actions.setLoginNew(true);
                  } else {
                    submit();
                  }
                }}
              >
                <div className=" flex items-start justify-start flex-col">
                  {auth ? (
                    <span className="  font-bold text-xs sm:text-sm text-white">
                      Place Bet
                    </span>
                  ) : (
                    <span className="  font-bold text-sm text-white">
                      Log In
                    </span>
                  )}
                  {profit()}
                </div>
                <span className="text-[10px] flex items-center justify-center gap-x-[1px]">
                  <span>
                    {betPlacing.stake ? (
                      <SVG_TimerIcon />
                    ) : (
                      <SVG_TimerDarkIcon />
                    )}
                  </span>
                  <span
                    className={`font-normal text-[16px] ${betPlacing.stake
                        ? "text-text_Quaternary"
                        : "text-[#b0b0b0]"
                      }`}
                  >
                    {betDelayLoader()}s
                  </span>
                </span>
              </button>
            </div>
          </div>
          <div className=" flex items-center justify-between w-full px-1 pt-3.5">
            <span className=" text-[13px] text-text_Ternary  font-medium">
              Confirm bet before placing
            </span>
            <label className="inline-flex items-center cursor-pointer relative">
              <input
                className="sr-only peer"
                type="checkbox"
                checked={betPlacing.confirmation}
                onChange={() =>
                  actions.setConfirmation(!betPlacing.confirmation)
                }
              />
              <div className="relative bg-bg_Quaternary  bg-white border-[0.5px] font-lato border-betSlipCancelBtnColor rounded-full peer-checked:bg-bg_SwitchCheckedBg h-7 w-14">
                {!!betPlacing.confirmation ? (
                  <span
                    className={`absolute top-1/2 text-white left-[5px] transform  -translate-y-1/2  font-bold text-text_Quaternary text-[10px]`}
                  >
                    ON
                  </span>
                ) : (
                  <span
                    className={`absolute top-1/2 text-white right-[5px] transform  -translate-y-1/2  font-bold text-[10px]`}
                  >
                    OFF
                  </span>
                )}
                <div
                  className={` h-full border-[0.5px] bg-bg_SwitchBtnRound  border-betSlipCancelBtnColor transition-all  ease-in-out aspect-square absolute ${!!betPlacing.confirmation ? "left-7" : "left-0"
                    } rounded-full `}
                ></div>
              </div>
            </label>
          </div>
        </div>
      ) : (
        <div className="w-full font-medium text-sm bg-bg_Quaternary rounded px-4  py-3 shadow text-text_Ternary ">
          Click on the odds to add selections to the betslip.
        </div>
      )}
    </>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export default connectBetPlacing()(BetPlacing);
